import { useEffect, useState } from "react";
import useDesignManagement from "pages/creative/pageV2/useDesignManagement";
import type { DesignView } from "../design/types";

const AUDIENCE_VARIABLES = new Set(
  [
    "first_name",
    "last_name",
    "full_name",
    "address",
    "address_1",
    "city",
    "state",
    "st",
    "zip",
    "crrt",
    "gpb_id",
    "pallet_id",
    "return_address",
    "cont_id",
    "endorse",
    "sequence",
  ].map((name) => name.toLowerCase())
);

const PLACEHOLDER_PATTERN = /\{\{([^}]+)\}\}/g;

export const scanPlaceholders = (htmlContent: string | null | undefined): string[] => {
  if (!htmlContent) return [];
  const found = new Set<string>();
  let match: RegExpExecArray | null;
  PLACEHOLDER_PATTERN.lastIndex = 0;
  while ((match = PLACEHOLDER_PATTERN.exec(htmlContent)) !== null) {
    const name = match[1].trim();
    if (name && !AUDIENCE_VARIABLES.has(name.toLowerCase())) found.add(name);
  }
  if (htmlContent.includes("data-qr-code")) found.add("qr_link");
  return Array.from(found);
};

export const useDesignPlaceholders = (design: DesignView | null, clientId?: string | null) => {
  const { getDesign } = useDesignManagement({ clientId: clientId || "" });
  const [placeholders, setPlaceholders] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!design?.id) {
      setPlaceholders([]);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    getDesign(design.id)
      .then((full: { htmlContent?: string } | null) => {
        if (!cancelled) setPlaceholders(scanPlaceholders(full?.htmlContent));
      })
      .catch(() => {
        if (!cancelled) setPlaceholders([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [design?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return { placeholders, loading };
};
